import { ERROR_CODE_MESSAGE_KEYS } from './error-codes.generated';

export { ERROR_CODE_MESSAGE_KEYS };

const STATUS_FALLBACK: Readonly<Record<number, string>> = {
  400: 'error.validation',
  401: 'error.unauthenticated',
  403: 'error.forbidden',
  404: 'error.not_found',
  409: 'error.conflict',
  423: 'error.tenant_read_only',
};

/**
 * کلید i18n پیام خطای API از `code` (قرارداد پایدار — error-codes.md §۱)؛ کلاینت هرگز بر پایه `title` تصمیم نمی‌گیرد.
 * کد ناشناخته (مثلاً `PHX-GEN-0{status}`) به کلید عمومی همان وضعیت و در غیر این صورت `error.unexpected` می‌رسد.
 */
export function errorMessageKey(code: string | undefined | null, status?: number): string {
  const key = (code && ERROR_CODE_MESSAGE_KEYS[code]) || (status !== undefined && STATUS_FALLBACK[status]);
  return `errors:${key || 'error.unexpected'}`;
}
